import React from "react";
// import background from "../../../assets/images/about/about-us-bg.jpg";

export default function Hero({ pageTitle, breadcrumbs = [], background }) {
  return (
    <section
      className="page-banner  bgs-cover overlay "
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="container">
        <div className="banner-inner">
          <h1 className="page-title hero-text">{pageTitle}</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {breadcrumbs &&
                breadcrumbs.length > 0 &&
                breadcrumbs.map((item) => (
                  <li key={Math.random()} className="breadcrumb-item">
                    <a href={item.path}>{item.name}</a>
                  </li>
                ))}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  );
}
